var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 22,
    viewBox: "0 0 25 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3414 6.15015C16.7343 3.72969 15.0907 1.44901 12.6702 1.05611C10.2497 0.663218 7.96905 2.30688 7.57615 4.72735C7.18325 7.14781 8.82692 9.42849 11.2474 9.82139C13.6678 10.2143 15.9485 8.57062 16.3414 6.15015Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1517 16.5379C10.715 14.1513 9.23693 11.76 6.85035 11.1967C4.46378 10.6334 2.07245 12.1115 1.50917 14.4981C0.945888 16.8846 2.42396 19.276 4.81053 19.8392C7.1971 20.4025 9.58843 18.9245 10.1517 16.5379Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0339 18.6595C22.7678 16.9255 22.7678 14.1143 21.0339 12.3803C19.3 10.6464 16.4887 10.6464 14.7548 12.3803C13.0209 14.1143 13.0209 16.9255 14.7548 18.6595C16.4887 20.3934 19.3 20.3934 21.0339 18.6595Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.bc351785c905c0ed9bfb425a4d644798.svg";
export { ForwardRef as ReactComponent };